import { browserListingHistory } from '@vs-shop/engine/listing/atom/listingHistory';
import { makeListingAtoms } from '@vs-shop/engine/listing/atom/makeListingAtoms';

import { CartClientAtom } from '../runtime/layers/ClientLayer';
import {
  RCPROFI_LISTING_CACHE,
  RCPROFI_LISTING_FACET_LAYOUT,
  RCPROFI_LISTING_ITEMS_PER_PAGE,
  RCPROFI_LISTING_SYNTAX,
  splitRcprofiListingQuery,
} from './listingConfig';

/** RCProfi accumulates products when the shopper loads the next page. */
export const rcprofiListingAtoms = makeListingAtoms({
  cache: RCPROFI_LISTING_CACHE,
  runtime: CartClientAtom,
  syntax: RCPROFI_LISTING_SYNTAX,
  history: browserListingHistory,
  itemsPerPage: RCPROFI_LISTING_ITEMS_PER_PAGE,
  keyPrefix: 'rcprofi/listing',
  pageMode: 'append',
  facetLayout: RCPROFI_LISTING_FACET_LAYOUT,
  splitQuery: splitRcprofiListingQuery,
});
